import { siteData } from "@/mocks/siteData";

export default function Benefits() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-2/5">
            <p className="text-secondary-500 font-semibold text-sm tracking-widest uppercase">Por que usar?</p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              cssbuy sheet?
            </h2>
            <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed max-w-md">
              Mais de milhares de usuários utilizam nosso CSSBuy Spreadsheet para encontrar produtos, vendedores e links organizados diariamente.
            </p>
          </div>

          <div className="lg:w-3/5 grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="bg-background-100 rounded-2xl overflow-hidden group cursor-pointer">
              <div className="h-48 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20clean%20workspace%20desk%20with%20laptop%20showing%20colorful%20spreadsheet%20data%20fashion%20sneakers%20and%20accessories%20neatly%20arranged%20on%20side%20warm%20ambient%20lighting%20minimalist%20setup%20cream%20beige%20background%20editorial%20product%20photography%20with%20soft%20shadows%20and%20organic%20composition&width=600&height=400&seq=benefit-v2-updated&orientation=landscape"
                  alt="Planilhas diárias organizadas"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3 whitespace-nowrap">
                  Atualizado
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Planilhas diárias organizadas</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">Links verificados e atualizados todos os dias para garantir qualidade e disponibilidade dos produtos.</p>
              </div>
            </div>

            <div className="bg-background-100 rounded-2xl overflow-hidden group cursor-pointer">
              <div className="h-48 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20product%20links%20collection%20displayed%20on%20minimalist%20warm%20surface%20multiple%20sneakers%20hoodies%20and%20designer%20items%20arranged%20in%20organized%20grid%20pattern%20soft%20natural%20window%20lighting%20editorial%20photography%20clean%20neutral%20cream%20background%20with%20subtle%20textile%20textures&width=600&height=400&seq=benefit-v2-links&orientation=landscape"
                  alt="Melhores vendedores Yupoo"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3 whitespace-nowrap">
                  Links
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Melhores vendedores Yupoo</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">Curadoria dos melhores álbuns Yupoo e vendedores confiáveis para cada categoria de produto.</p>
              </div>
            </div>

            <div className="bg-background-100 rounded-2xl overflow-hidden group cursor-pointer">
              <div className="h-48 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20guidebook%20and%20fashion%20shopping%20items%20on%20warm%20beige%20desk%20natural%20light%20soft%20shadows%20editorial%20style%20product%20photography%20neutral%20tones%20open%20notebook%20with%20handwritten%20notes%20next%20to%20sneakers%20and%20accessories%20clean%20aesthetic%20composition&width=600&height=400&seq=benefit-v2-guias&orientation=landscape"
                  alt="Passo a passo completo"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3 whitespace-nowrap">
                  Guias
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Passo a passo completo</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">Guias detalhados em português desde a compra até o envio, com dicas de segurança e economia.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}